export default function setFavicon(url) {
    const link = document.createElement('link')
    link.rel = 'icon'
    link.href = url

    const head = document.querySelector('head')
    const existingLink = head.querySelector('link[rel="icon"]')

    if (existingLink) {
        head.removeChild(existingLink)
    }

    head.appendChild(link)
}
